import { useRouter } from 'next/router';
import { omit } from 'lodash-es';

const useHasFilters = ({
  pinnedFilters = [],
  omitParams = [
    'page',
    'view',
    'pageSize',
    'order',
    'orderBy',
    'query',
    'viewMode',
  ],
}) => {
  const router = useRouter();

  const hasFilters =
    pinnedFilters?.length > 0 ||
    Object.keys(omit(router.query, omitParams)).length > 0;

  return {
    hasFilters,
  };
};

export default useHasFilters;
